import { ColumnBuilder } from './ColumnBuilder'
import { ClassesBuilder } from './ClassesBuilder'
import { StylesParser } from '../StylesParser'

export class RowBuilder {
  constructor(row) {
    this.row = row
  }

  build() {
    this.rowClasses = this.getRowClasses()
    window.StylesBuilder.add(this.getRowStyles())
    this.id = this.row.id
    this.columns = this.row.columns.map(column => (new ColumnBuilder(column)).build()).join('')
    return this.buildHtml()
  }

  getRowClasses() {
    return new Object({
      classes: (new ClassesBuilder(this.row.classes)).parseClasses().join(' '),
    })
  }

  getRowStyles() {
    return new Object({
      id: this.row.id,
      styles: {
        desktop: (new StylesParser(this.row.styles, 'desktop')).parse(),
        tablet: (new StylesParser(this.row.styles, 'tablet')).parse(),
        phone: (new StylesParser(this.row.styles, 'phone')).parse()
      }
    })
  }

  buildHtml() {
    return `<div class="wf-px-2 wf-flex wf-w-full wf-flex-row wf-flex-wrap ${this.rowClasses.classes}">
      ${this.columns}
    </div>`
  }
 }
